export const STRIPE_PUBLIC_KEY = 'pk_test_51PxnnRDwpgfRX3jZFlsFFJkv7l82JqlzyCivO10qViWhNMxz1oKj8R8o6MFy7ZoMgDM9Rzu2c0YIiezd9uhpEwx300BTzZ99cE';
export const API_URL = 'http://localhost:8000/api/v1'; 